import "./Projects.css";
import ProjectCard from "./ProjectCard";

const Projects = () => {
  const secSubText = `The smallest-circle problem (also known as minimum covering 
    circle problem, bounding circle problem, smallest enclosing circle problem) is 
    a mathematical problem of computing the smallest circle that contains all of a 
    given set of points in the Euclidean plane. (Wikipedia)`;
  const dqn1SubText = `Reinforcement learning (RL) is an interdisciplinary area of 
    machine learning and optimal control concerned with how an intelligent agent ought 
    to take actions in a dynamic environment in order to maximize the cumulative reward. (Wikipedia)`;

  return (
    <div className="projects-site-container">
      <div className="projects-container">
        <h1 className="about-h1">Projects</h1>
      </div>
      <div className="projects-cards-container">
        <div className="projects-cards-wrapper">
          <ul className="projects-cards">
            <ProjectCard
              img="sec_coverimg.png"
              title="Smallest enclosing circle"
              path="/projects/sec"
              subText={secSubText}
              external={false}
            />
          </ul>
        </div>
        <div className="projects-cards-wrapper">
          <ul className="projects-cards">
            <ProjectCard
              img="dqn_coverimg.jpg"
              title="Reinforcement Learning using DQN"
              path="/blog/dqn"
              subText={dqn1SubText}
              external={true}
            />
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Projects;
